<template>
  <v-row no-gutters class="pt-5 pr-2">
    <v-col>
      <card-title-row translation-path="sidebar.waterMetersWaterDissolution" :has-buttons="false" />
      <card-title-row is-subtitle :straight-title="title" :has-buttons="false" class="pt-5 pb-4" />
      <sidebar-row v-if="isFetched">
        <v-col cols="auto" class="px-0 pt-0">
          <v-row no-gutters class="align-center" v-for="(range, idx) in [...rangesText].reverse()" :key="idx">
            <v-col cols="auto" class="pr-1">
              <legend-layer-list-icon :color="range.color" layer-type="point" size="45px"></legend-layer-list-icon>
            </v-col>
            <v-col cols="auto" class="text-body-2 pt-1">
              {{ range.text }}
            </v-col>
          </v-row>
        </v-col>
      </sidebar-row>
      <template v-else>
        <main-loader> </main-loader>
      </template>
    </v-col>
  </v-row>
</template>
<script>
import { call } from 'vuex-pathify';

import CardTitleRow from '@/components/CardTitleRow';
import MainLoader from '@/components/MainLoader';
import SidebarRow from '@/components/SidebarRow';
import LegendLayerListIcon from '@/components/LegendLayerListIcon';

export default {
  name: 'WaterDissolutionWatermeters',
  components: {
    SidebarRow,
    CardTitleRow,
    MainLoader,
    LegendLayerListIcon,
  },
  computed: {
    title() {
      const m3 = new DOMParser().parseFromString('m&sup3', 'text/html').body.textContent;
      return `${this.$i18n.t('sidebar.dialyAverageWaterConsumption')} (${m3})`;
    },
  },
  data: () => ({
    isFetched: false,
    rangesText: [],
  }),
  methods: {
    getMinMaxWaterConsumptionValues: call('billings/getMinMaxWaterConsumptionValues'),
    updateWaterDissolutionVisualisationMapLegend(data) {
      const rangesLength = data.rangesColors.length;
      const rangesText = [];
      data.rangesColors.forEach((color, idx) => {
        let rangeText = '';
        if (idx == '0') {
          rangeText = `0 - ${data.ranges[idx]}`;
        } else if (idx == rangesLength - 1) {
          rangeText = `> ${data.ranges[idx - 1]}`;
        } else {
          rangeText = `${data.ranges[idx - 1]} - ${data.ranges[idx]}`;
        }
        rangesText.push({ color, text: rangeText });
      });
      rangesText.unshift({ color: 'grey', text: this.$i18n.t('default.noData') });
      this.rangesText = rangesText;
      this.isFetched = true;
    },
    async toggleWaterDissolutionVisualisation(nV) {
      if (nV) {
        this.isWaterDissolutionVisualisationLoading = true;
        await this.getMinMaxWaterConsumptionValues();
        this.isWaterDissolutionVisualisationLoading = false;
      }
      this.$root.$emit('toggleWaterDissolutionVisualisation', nV);
    },
    async watermetersFetched() {
      await this.toggleWaterDissolutionVisualisation(true);
      this.isFetched = true;
    },
  },
  mounted() {
    this.$root.$off('updateWaterDissolutionVisualisationMapLegend');
    this.$root.$on('watermetersFetched', this.watermetersFetched);
    this.$root.$on('updateWaterDissolutionVisualisationMapLegend', this.updateWaterDissolutionVisualisationMapLegend);
    this.toggleWaterDissolutionVisualisation(true);
  },
  beforeDestroy() {
    this.$root.$off('watermetersFetched');
  },
};
</script>
<style lang="scss" scoped>
.checkbox-label {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: rgba(0, 0, 0, 0.87);
}
</style>
